import React, { useState } from "react";
import Login from "../Auth/Login/Login";
import Modal from "react-modal";
import Footer from "../../components/Footer/Footer";
import AppBar from "../../components/AppBar/AppBar";
import HowItWorksGroup from "../../components/HowItWorksGroup/HowItWorksGroup";
import { Icons, Button } from "../../components/ui";

Modal.setAppElement("#root"); // Set the app root element for accessibility

const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <AppBar showLogout={false} />

      {/* Hero band */}
      <header className="relative overflow-hidden border-b border-gray-100">
        <img
          className="absolute inset-0 w-full h-full object-cover"
          alt="ImageShield"
          src="https://flashbackportfoliouploads.s3.amazonaws.com/Aarvi Media-aarvimedia/Wedding/1723054857157-S_Y03064 copy.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/55" />
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 py-24 sm:py-32 flex justify-center">
          <Button onClick={openModal} className="px-6 py-3 text-base">
            Get Started
          </Button>
        </div>
      </header>

      {/* Features */}
      <div className="fade-in max-w-[1400px] mx-auto px-4 sm:px-6 py-16 space-y-16">
        <section className="bg-white border border-gray-200 rounded-2xl shadow-card p-6 sm:p-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-6">
            <span className="text-brand-600">Instant &amp; Secure</span> Photo Sharing
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <img
              src="assets/feature-photo-share.png"
              alt="Instant & Secure Photo Sharing"
              className="w-full rounded-xl border border-gray-200 object-cover"
            />
            <HowItWorksGroup index={0} />
          </div>
        </section>

        <section className="bg-white border border-gray-200 rounded-2xl shadow-card p-6 sm:p-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-6">
            <span className="text-brand-600">Auto Curated</span> Wedding Albums
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <HowItWorksGroup index={1} />
            <img
              src="assets/feature-curate-album.png"
              alt="Auto Curated Wedding Albums"
              className="w-full rounded-xl border border-gray-200 object-cover"
            />
          </div>
        </section>
      </div>

      <Footer />

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Login Modal"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-md bg-white rounded-2xl shadow-card p-6 outline-none z-[1000]"
        overlayClassName="fixed inset-0 bg-black/75 z-[999]"
      >
        <button
          onClick={closeModal}
          aria-label="Close"
          className="absolute top-3 right-3 w-9 h-9 grid place-items-center rounded-lg text-slate-500 hover:bg-gray-100 hover:text-slate-800 transition z-10"
        >
          <Icons.X className="w-5 h-5" />
        </button>
        <div className="text-center">
          <Login showAppBar={false} />
        </div>
      </Modal>
    </>
  );
};

export default About;
